import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ExportRenderEventsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type ExportRenderEventsSubscription = { __typename?: 'Subscription', exportRenderEvents: { __typename?: 'RenderJobCompletePayload', jobId: string, items: Array<{ __typename?: 'RenderJobCompleteItem', compositionId: string, filePath: string, fileName: string, workAreaStart?: number | null, workAreaDuration?: number | null, framesPerSecond?: number | null }> } | { __typename?: 'RenderJobFailedPayload', jobId: string, reason: Types.RenderJobFailedReason } | { __typename?: 'RenderJobStartedPayload', jobId: string, totalItems: number, completedItems: number } };


export const ExportRenderEvents = /*#__PURE__*/ gql`
    subscription ExportRenderEvents {
  exportRenderEvents {
    ... on RenderJobFailedPayload {
      jobId
      reason
    }
    ... on RenderJobStartedPayload {
      jobId
      totalItems
      completedItems
    }
    ... on RenderJobCompletePayload {
      jobId
      items {
        compositionId
        filePath
        fileName
        workAreaStart
        workAreaDuration
        framesPerSecond
      }
    }
  }
}
    ` as unknown as DocumentNode<ExportRenderEventsSubscription, ExportRenderEventsSubscriptionVariables>;

          

          export const useExportRenderEventsSubscription = (options?:SubscriptionHookOptions<ExportRenderEventsSubscription, ExportRenderEventsSubscriptionVariables>) => useSubscription(ExportRenderEvents, options);

          

          export type ExportRenderEventsSubscriptionOptions = SubscriptionHookOptions<ExportRenderEventsSubscription, ExportRenderEventsSubscriptionVariables>;

          

          export type ExportRenderEventsSubscriptionResult = ReturnType<typeof useExportRenderEventsSubscription>;

          
